
import React, { Component } from 'react'
import { observer } from 'mobx-react';
import JudgementCard from './JudgementCard'
import { List } from 'antd'
@observer(['UserStore'])
class Judgements extends Component {
    render() {
        let wagers = this.props.UserStore.user.customWagersJudged;
        let wagerList = wagers.map((wagerId) =>
            <List.Item key={wagerId} style={{ padding: "15px" }}>
                <JudgementCard wagerId={wagerId} />
            </List.Item>
        );
        return (
            <div>
                <List
                    grid={{
                        gutter: 16, xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 5,
                    }} >{wagerList}</List>
            </div>
        )
    }
}

export default Judgements;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/Judgements.js